// src/components/servicePartnerFinder/FilterCheckbox.tsx
import React, { FC } from 'react'

interface FilterCheckboxProps {
    label: string
    checked: boolean
    onChange: () => void
    tooltipText?: string
}

export const FilterCheckbox: FC<FilterCheckboxProps> = ({ label, checked, onChange, tooltipText }) => (
    <div className="flex items-center gap-2">
        <label className="flex items-center gap-3 cursor-pointer group">
            <div
                className={`w-6 h-6 box-border border rounded-[4px] flex items-center justify-center bg-white/50 transition-colors border-[var(--color-base-signal-500)] `}
            >
                {checked && (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M20 6L9 17L4 12"
                            stroke="black"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                )}
                <input
                    type="checkbox"
                    className="hidden"
                    checked={checked}
                    onChange={onChange}
                />
            </div>
            <span className="text-secondary text-body-base font-medium select-none">{label}</span>
        </label>

        {tooltipText && (
            <div className="relative group/tooltip flex items-center">
                <div className="cursor-help text-brand-sky-500">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2" />
                        <path d="M12 17V11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        <circle cx="12" cy="7" r="0.5" fill="currentColor" stroke="currentColor" strokeWidth="1" />
                    </svg>
                </div>

                <div className="absolute left-full top-1/2 -translate-y-1/2 ml-2 w-48 p-2 bg-slate-800 text-white text-xs rounded opacity-0 invisible group-hover/tooltip:opacity-100 group-hover/tooltip:visible transition-all z-50 pointer-events-none shadow-lg">
                    {tooltipText}
                    {/* Triangle pointing left */}
                    <div className="absolute right-full top-1/2 -translate-y-1/2 w-0 h-0 border-t-4 border-t-transparent border-b-4 border-b-transparent border-r-4 border-r-slate-800"></div>
                </div>
            </div>
        )}
    </div>
)
